<template>
  <Error
    v-if="siteStructureNotFound"
    :error="err"
  />
  <Default v-else>
    <Error :error="err" />
  </Default>
</template>

<script>
import Default from './layouts/default.vue';
import Error from './components/pages/Error.vue';

const SITE_STRUCTURE_ERROR_TEXT = '(Site Structure not found)';

export default {
  components: {
    Default,
    Error,
  },
  props: {
    error: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    siteStructureNotFound() {
      return this.error.message.includes(SITE_STRUCTURE_ERROR_TEXT);
    },
    err() {
      const error = { ...this.error };
      if (this.siteStructureNotFound) {
        error.message = error.message.replace(SITE_STRUCTURE_ERROR_TEXT, '');
      }
      return error;
    },
  },
};
</script>

<style lang="scss" scoped>
.error-page {
  display: flex;
  justify-content: center;
  font-style: normal;
  font-size: 14px;

  .content {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    padding: 100px;
    overflow: auto;

    @media screen and (max-width: 600px) {
      padding: 50px;
    }

    #status-code {
      color: #747474;
    }

    p {
      padding: 30px 20px 50px 0px;
    }

    h1 {
      font-size: 45px;
    }

    #go-Home-wrapper {
      a {
        margin-top: 25px;
        text-decoration: none;
        color: #ffffff;
        padding: 10px 15px;
        border-radius: 3px;
        cursor: pointer;
      }
      a:focus-visible {
        outline: 2px solid -webkit-focus-ring-color;
        outline-offset: 1px;
        box-shadow: inset 0 0 0px 2px #ffffff;
      }
    }
  }
}
</style>
